// NBN Product Page Enhancements - Trust Badges
(function() {
  'use strict';

  const BADGES_HTML = `
    <div class="nbn-badges" style="display:flex;gap:12px;justify-content:center;flex-wrap:wrap;padding:12px 0 8px;margin-top:8px;border-top:1px solid rgba(0,0,0,0.08);">
      <div style="text-align:center;font-size:11px;color:#616161;line-height:1.3;min-width:64px;">
        <div style="font-size:16px;margin-bottom:3px;">🔒</div>
        <div>Plain packaging</div>
      </div>
      <div style="text-align:center;font-size:11px;color:#616161;line-height:1.3;min-width:64px;">
        <div style="font-size:16px;margin-bottom:3px;">🧾</div>
        <div>Discreet billing</div>
      </div>
      <div style="text-align:center;font-size:11px;color:#616161;line-height:1.3;min-width:64px;">
        <div style="font-size:16px;margin-bottom:3px;">🚀</div>
        <div>Fast dispatch</div>
      </div>
      <div style="text-align:center;font-size:11px;color:#616161;line-height:1.3;min-width:64px;">
        <div style="font-size:16px;margin-bottom:3px;">🛡️</div>
        <div>1+ yr warranty</div>
      </div>
    </div>`;

  function injectBadges() {
    if (document.querySelector('.nbn-badges')) return;

    // Inject after the entire product-add-to-cart-container (below ATC button)
    const container = document.querySelector('.product-add-to-cart-container');
    if (!container) return;

    const badgesDiv = document.createElement('div');
    badgesDiv.innerHTML = BADGES_HTML;
    container.insertAdjacentElement('afterend', badgesDiv.firstElementChild);
  }

  const SEARCH_PROMPTS = [
    { label: 'Best vibrators for beginners', query: 'Best vibrators for beginners' },
    { label: "Best men's sex toys", url: '/collections/male-masturbators?sort_by=best-selling' },
    { label: 'Couples toys', query: 'Couples toys' },
    { label: 'Beginner anal toys', query: 'Beginner anal toys' },
    { label: 'Gift for wife', url: '/collections/gifts-for-her?sort_by=best-selling' },
    { label: 'Rabbit vibrators', url: '/collections/rabbit-vibrators?sort_by=best-selling' },
    { label: 'Remote control toys', url: '/collections/app-controlled-vibrators?sort_by=best-selling' },
    { label: 'Fleshlight toys', url: '/collections/fleshlights?sort_by=best-selling' },
    { label: 'Quiet vibrators', query: 'Quiet vibrators' },
    { label: 'Lube for sensitive skin', query: 'Lube for sensitive skin' }
  ];

  const SEARCH_PLACEHOLDERS = [
    'Search "gift for wife"'
  ];

  function buildSearchUrl(prompt) {
    if (prompt.url) return prompt.url;

    const params = new URLSearchParams();
    params.set('q', prompt.query || prompt.label);
    params.set('type', 'product');
    params.set('options[unavailable_products]', 'last');
    params.set('nbn_prompt', '1');
    return '/search?' + params.toString();
  }

  function clearPromptSearchState(input) {
    const params = new URLSearchParams(window.location.search);
    if (params.get('nbn_prompt') !== '1') return;

    const promptQuery = params.get('q') || '';
    if (!promptQuery || input.value !== promptQuery) return;

    input.value = '';
    input.setAttribute('placeholder', SEARCH_PLACEHOLDERS[0]);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));

    params.delete('nbn_prompt');
    const cleanSearch = params.toString();
    const cleanUrl = window.location.pathname + (cleanSearch ? '?' + cleanSearch : '') + window.location.hash;
    window.history.replaceState(window.history.state, '', cleanUrl);
  }

  function injectSearchPromptStyles() {
    if (document.getElementById('nbn-search-prompts-style')) return;

    const style = document.createElement('style');
    style.id = 'nbn-search-prompts-style';
    style.textContent = `
      .nbn-search-prompts {
        display: flex;
        flex-wrap: wrap;
        gap: 7px;
        margin: 8px 0 0;
        pointer-events: auto;
        position: relative;
        width: 100%;
        z-index: 5;
      }

      .nbn-search-prompt {
        appearance: none;
        border: 1px solid rgba(237, 3, 124, 0.28);
        border-radius: 999px;
        background: #fff;
        color: #2b2b2b;
        cursor: pointer;
        font: inherit;
        font-size: 12px;
        font-weight: 600;
        line-height: 1.2;
        padding: 7px 10px;
        pointer-events: auto;
        position: relative;
        text-align: left;
        transition: background 160ms ease, border-color 160ms ease, color 160ms ease;
      }

      .nbn-search-prompt:hover,
      .nbn-search-prompt:focus-visible,
      .nbn-search-more:hover,
      .nbn-search-more:focus-visible {
        background: #ed037c;
        border-color: #ed037c;
        color: #fff;
        outline: none;
      }

      .nbn-search-prompts:not(.is-expanded) .nbn-search-prompt.is-desktop-extra {
        display: none;
      }

      .nbn-search-more {
        appearance: none;
        border: 1px solid rgba(237, 3, 124, 0.38);
        border-radius: 999px;
        background: #fff7fb;
        color: #2b2b2b;
        cursor: pointer;
        font: inherit;
        font-size: 12px;
        font-weight: 700;
        line-height: 1.2;
        padding: 7px 10px;
        pointer-events: auto;
        position: relative;
        text-align: left;
        transition: background 160ms ease, border-color 160ms ease, color 160ms ease;
      }

	      @media (max-width: 767px) {
	        body.open-search .header .searchform.nbn-header-search-reveal.is-mobile-open,
	        body.nbn-mobile-search-open .header .searchform.nbn-header-search-reveal.is-mobile-open {
	          height: auto !important;
	          max-height: 108px !important;
	          overflow: visible !important;
	        }

	        body.open-search .header,
	        body.nbn-mobile-search-open .header,
	        body.open-search .header-section,
	        body.nbn-mobile-search-open .header-section {
	          height: auto !important;
	        }

	        .nbn-search-prompts {
	          background: #fff;
	          border-bottom: 1px solid rgba(237, 3, 124, 0.12);
	          box-shadow: none;
	          cursor: grab;
	          overflow-x: auto;
	          overflow-y: hidden;
	          flex-wrap: nowrap;
	          margin: 7px 0 0;
	          max-width: 100%;
	          min-width: 0;
	          padding: 8px 0 3px;
	          scroll-behavior: smooth;
	          scrollbar-width: none;
	          touch-action: pan-x;
	          -webkit-overflow-scrolling: touch;
	        }

	        .nbn-search-prompts.is-dragging {
	          cursor: grabbing;
	          scroll-behavior: auto;
	        }

	        .nbn-search-prompts::-webkit-scrollbar {
	          display: none;
	        }

        .nbn-search-prompt {
          flex: 0 0 auto;
          white-space: nowrap;
        }

        .nbn-search-prompts:not(.is-expanded) .nbn-search-prompt.is-desktop-extra {
          display: inline-block;
        }

        .nbn-search-more {
          display: none;
        }
      }
    `;
    document.head.appendChild(style);
  }

	  function enhanceSearchForms() {
	    injectSearchPromptStyles();

    document.querySelectorAll('.searchform form').forEach(function(form) {
      if (form.dataset.nbnSearchPrompts === 'true') return;

      const input = form.querySelector('input[type="search"][name="q"]');
      const formRow = form.querySelector('.searchform--form');
      if (!input || !formRow) return;

      form.dataset.nbnSearchPrompts = 'true';
      if (!input.value) {
        const index = Math.floor(Date.now() / 30000) % SEARCH_PLACEHOLDERS.length;
        input.setAttribute('placeholder', SEARCH_PLACEHOLDERS[index]);
      }

	      const promptWrap = document.createElement('div');
	      promptWrap.className = 'nbn-search-prompts';
	      promptWrap.setAttribute('aria-label', 'Popular search prompts');
	      let dragStartX = 0;
	      let dragStartY = 0;
	      let dragStartScrollLeft = 0;
	      let isPointerDragging = false;
	      let didDrag = false;
	      let dragResetTimer;

	      function scheduleDragReset() {
	        window.clearTimeout(dragResetTimer);
	        dragResetTimer = window.setTimeout(function() {
	          didDrag = false;
	        }, 160);
	      }

	      promptWrap.addEventListener('pointerdown', function(event) {
	        if (!window.matchMedia('(max-width: 767px)').matches) return;

	        dragStartX = event.clientX;
	        dragStartY = event.clientY;
	        dragStartScrollLeft = promptWrap.scrollLeft;
	        isPointerDragging = true;
	        didDrag = false;
	        promptWrap.classList.add('is-dragging');
	        if (promptWrap.setPointerCapture) {
	          promptWrap.setPointerCapture(event.pointerId);
	        }
	      });

	      promptWrap.addEventListener('pointermove', function(event) {
	        if (!isPointerDragging) return;

	        const dragDistance = event.clientX - dragStartX;
	        const verticalDistance = event.clientY - dragStartY;
	        if (Math.abs(dragDistance) > 4 && Math.abs(dragDistance) > Math.abs(verticalDistance)) {
	          didDrag = true;
	          event.preventDefault();
	        }
	        promptWrap.scrollLeft = dragStartScrollLeft - dragDistance;
	      });

	      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function(eventName) {
	        promptWrap.addEventListener(eventName, function() {
	          isPointerDragging = false;
	          promptWrap.classList.remove('is-dragging');
	          scheduleDragReset();
	        });
	      });

	      promptWrap.addEventListener('touchstart', function(event) {
	        if (!window.matchMedia('(max-width: 767px)').matches || !event.touches.length) return;

	        dragStartX = event.touches[0].clientX;
	        dragStartY = event.touches[0].clientY;
	        dragStartScrollLeft = promptWrap.scrollLeft;
	        didDrag = false;
	        promptWrap.classList.add('is-dragging');
	      }, { passive: true });

	      promptWrap.addEventListener('touchmove', function(event) {
	        if (!event.touches.length) return;

	        const dragDistance = event.touches[0].clientX - dragStartX;
	        const verticalDistance = event.touches[0].clientY - dragStartY;
	        if (Math.abs(dragDistance) > 4 && Math.abs(dragDistance) > Math.abs(verticalDistance)) {
	          didDrag = true;
	          promptWrap.scrollLeft = dragStartScrollLeft - dragDistance;
	          event.preventDefault();
	        }
	      }, { passive: false });

	      ['touchend', 'touchcancel'].forEach(function(eventName) {
	        promptWrap.addEventListener(eventName, function() {
	          promptWrap.classList.remove('is-dragging');
	          scheduleDragReset();
	        }, { passive: true });
	      });

	      SEARCH_PROMPTS.forEach(function(prompt, index) {
	        const button = document.createElement('button');
	        button.type = 'button';
	        button.className = 'nbn-search-prompt';
	        if (index > 3) {
	          button.classList.add('is-desktop-extra');
	        }
	        button.dataset.nbnSearchUrl = buildSearchUrl(prompt);
	        button.textContent = prompt.label;
	        button.addEventListener('click', function(event) {
	          if (didDrag && Math.abs(promptWrap.scrollLeft - dragStartScrollLeft) > 8) {
	            event.preventDefault();
	            didDrag = false;
	            return;
	          }
	          input.value = prompt.query || prompt.label;
	          window.location.assign(button.dataset.nbnSearchUrl);
	        });
        promptWrap.appendChild(button);
      });

	      const moreButton = document.createElement('button');
	      moreButton.type = 'button';
	      moreButton.className = 'nbn-search-more';
	      moreButton.textContent = 'More searches';
	      moreButton.setAttribute('aria-expanded', 'false');
	      moreButton.addEventListener('click', function() {
	        const isExpanded = promptWrap.classList.toggle('is-expanded');
	        moreButton.textContent = isExpanded ? 'Less searches' : 'More searches';
	        moreButton.setAttribute('aria-expanded', String(isExpanded));
	      });
	      promptWrap.appendChild(moreButton);

      formRow.insertAdjacentElement('afterend', promptWrap);
      clearPromptSearchState(input);
    });
  }

  function injectReserveAnchor() {
    if (document.getElementById('nbn-reserve-container')) return;
    const addButton = document.getElementById('AddToCart');
    if (!addButton) return;
    const reserve = document.createElement('div');
    reserve.id = 'nbn-reserve-container';
    reserve.style.marginTop = '8px';
    addButton.insertAdjacentElement('afterend', reserve);
  }

  function loadFreshWidget() {
    injectReserveAnchor();
    if (document.getElementById('nbn-reserve-toggle')) return;
    const script = document.createElement('script');
    script.src = '/cdn/shop/t/23/assets/nbn-widget.js?v=202605310807';
    script.defer = true;
    document.head.appendChild(script);
  }

  function refreshCachedHomepageHero() {
    if (window.location.pathname !== '/') return;

    const section = document.querySelector('[id^="shopify-section"][id*="slideshow_xaDdw3"]');
    if (!section) return;
    if (section.innerHTML.indexOf('nbn-live-bogo-narrow-final') !== -1) return;

    const sectionId = section.id.replace('shopify-section-', '');
    fetch('/?sections=' + encodeURIComponent(sectionId) + '&nbn_hero_refresh=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function(response) { return response.ok ? response.json() : null; })
      .then(function(payload) {
        if (!payload || !payload[sectionId]) return;
        if (payload[sectionId].indexOf('nbn-live-bogo-narrow-final') === -1) return;
        section.outerHTML = payload[sectionId];
      })
      .catch(function() {});
  }

  function init() {
    refreshCachedHomepageHero();
    injectReserveAnchor();
    injectBadges();
    enhanceSearchForms();
    loadFreshWidget();

    // Watch for Brauz/JS rebuilds
    const observer = new MutationObserver(function() {
      if (!document.querySelector('.nbn-badges') && document.querySelector('.product-add-to-cart-container')) {
        setTimeout(injectBadges, 50);
      }
      if (!document.getElementById('nbn-reserve-container') && document.getElementById('AddToCart')) {
        setTimeout(loadFreshWidget, 50);
      }
      enhanceSearchForms();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Fallback retries
    setTimeout(injectBadges, 300);
    setTimeout(injectBadges, 800);
    setTimeout(injectBadges, 2000);
    setTimeout(injectBadges, 4000);
    setTimeout(loadFreshWidget, 300);
    setTimeout(loadFreshWidget, 800);
    setTimeout(loadFreshWidget, 2000);
    setTimeout(loadFreshWidget, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* NBN same-day delivery article cache cleanup - 2026-06-08 */
(function () {
  function cleanSameDayArticle() {
    if (window.location.pathname.indexOf('/blogs/naughty-but-nice-blog-news-education-and-more/same-day-sex-toy-delivery-brisbane') === -1) return;
    var el = document.querySelector('.post-content.rte');
    if (!el) return;
    var html = el.innerHTML;
    var start = html.indexOf('<p><strong>SEO Meta Title:</strong>');
    var tagNeedle = '<strong>Tags:</strong> Same Day Delivery, Sex Toys Brisbane, Adult Toy Delivery, 2-Hour Delivery, Naughty But Nice</p>';
    if (start !== -1) {
      var end = html.indexOf(tagNeedle, start);
      if (end !== -1) html = html.slice(0, start) + html.slice(end + tagNeedle.length);
    }
    html = html.split('---').join('');
    html = html.replace('<p>The service is available up to 60km from store locations, subject to your address, the time of day and whether the products in your cart are available from the same store. If everything lines up, the 2-hour delivery option appears at checkout.</p>', '<p>The service is available up to 60km from store locations, subject to your address, the time of day and live fulfilment availability across our store network. If everything lines up, the 2-hour delivery option appears at checkout.</p>');
    html = html.replace('<p><strong>Choose products online.</strong> Browse naughtybutnice.au and add what you want to cart. Same day delivery works best when every item is available at one store, so avoid mixing lots of products from different categories if the order is urgent.</p>', '<p><strong>Choose products online.</strong> Browse naughtybutnice.au and add what you want to cart. If items need to come from more than one location, checkout may still offer local delivery, but the delivery rate can be higher.</p>');
    html = html.replace('<p>Most adult toys and intimacy products can be eligible when they are in stock at the same store. That includes vibrators, wand massagers, dildos, plugs, prostate toys, strokers, cock rings, bondage accessories, lingerie, lube, condoms and toy cleaners.</p>', '<p>Most adult toys and intimacy products can be eligible when they are available through NBN\'s local fulfilment network. That includes vibrators, wand massagers, dildos, plugs, prostate toys, strokers, cock rings, bondage accessories, lingerie, lube, condoms and toy cleaners.</p>');
    html = html.replace('<p>For a simple first order, start with products from the same collection. Popular quick-delivery choices include a vibrator with water-based lube, a couples toy with toy cleaner, or a beginner bondage kit with blindfolds and restraints.</p>', '<p>For a simple first order, start with products that suit the moment. Popular quick-delivery choices include a vibrator with water-based lube, a couples toy with toy cleaner, or a beginner bondage kit with blindfolds and restraints.</p>');
    html = html.replace('<p>Same day delivery may not appear for oversized items, pre-orders, products that are not available from one store, addresses outside the radius or orders placed after the daily cutoff.</p>', '<p>Same day delivery may not appear for oversized items, pre-orders, addresses outside the radius, orders placed after the daily cutoff or combinations checkout cannot fulfil locally that day.</p>');
    html = html.replace('<p>If you expected same day delivery but cannot see it at checkout, the most common reason is stock split. For example, one product might be available at Cannon Hill while another is only available at Capalaba. The order needs to be packed from one store for local delivery to work.</p>', '<p>If you expected same day delivery but cannot see it at checkout, it usually means the address, timing, product availability or fulfilment combination cannot be serviced locally at that moment.</p>');
    if (html !== el.innerHTML) el.innerHTML = html;
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanSameDayArticle);
  } else {
    cleanSameDayArticle();
  }
  window.addEventListener('load', cleanSameDayArticle);
}());
